{
  "header": {
    "title": "Chat",
    "subtitle": "Tvoj AI fitness tréner"
  },
  "mobileHeader": {
    "title": "AI Tréner",
    "back": "Späť",
    "history": "História konverzácií"
  },
  "input": {
    "placeholder": "Vytvor tréning zameraný na hrudník..."
  },
  "list": {
    "title": "Konverzácie",
    "newChat": "Nová konverzácia",
    "close": "Zavrieť",
    "searchPlaceholder": "Hľadať konverzácie...",
    "defaultName": "Konverzácia",
    "actions": "Možnosti konverzácie",
    "delete": "Odstrániť",
    "deleteTitle": "Odstrániť konverzáciu?",
    "deleteDescription": "Táto konverzácia bude natrvalo odstránená.",
    "sections": {
      "today": "Dnes",
      "yesterday": "Včera",
      "previous7Days": "Predchádzajúcich 7 dní",
      "older": "Staršie"
    }
  }
}
